import { Input } from 'antd';
import { InputWrapper, TextAreaWrapper } from './styles/input.style';

const { TextArea } = Input;

const WDStyledInput = InputWrapper(Input);

const Textarea = TextAreaWrapper(TextArea);

export default WDStyledInput;
export { Textarea };


// WEBPACK FOOTER //
// ./src/components/UI/Input.js